import * as Types from './types'

export const emptyState =
  <T>(initializer: Types.InitializeModalState<T>): Types.State<T> => {
  return {
    data: initializer(),
    isOpen: false,
    isSubmitting: false,
    submitSuccess: false,
  }
}

export const emptyFileModalData: Types.FileModalData = {
  name: '',
}



// WEBPACK FOOTER //
// ./src/components/modal/constants.ts